'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track3 = require('./utils/track');

var _track4 = _interopRequireDefault(_track3);

var _getUserId = require('./utils/cookie/getUserId');

var _getUserId2 = _interopRequireDefault(_getUserId);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OUTCOME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_USER_ID, _propTypes3.default.number), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a email verification
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackEmailVerification() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var userId = (0, _getUserId2.default)();
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_EMAIL_VERIFICATION + ' event');
    if (userId) {
        var _track;

        return (0, _track4.default)(_events.EVENT_EMAIL_VERIFICATION, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_OUTCOME, traits[_traits.TRAIT_OUTCOME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_USER_ID, userId), _track));
    }

    return (0, _track4.default)(_events.EVENT_EMAIL_VERIFICATION, (0, _defineProperty3.default)({}, _traits.TRAIT_OUTCOME, traits[_traits.TRAIT_OUTCOME]));
}

exports.default = trackEmailVerification;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/trackEmailVerification.js
// module id = 1943
// module chunks = 1